module.exports = __webpack_public_path__ + "media/toolkits/checkmark-bullets-27c91953.png";